import serviceMobileApp from '../assets/service-mobile-app.jpg';
import serviceWebDev from '../assets/service-web-dev.jpg';
import serviceDatabase from '../assets/service-database.jpg';
import serviceCloudDevops from '../assets/service-cloud-devops.jpg';

const services = [
	{
		id: '01',
		title: 'Mobile App Development',
		description:
			'Native and cross-platform applications built for healthcare operations, patient-facing workflows, and internal process automation.',
		tags: ['Cross-Platform', 'Native', 'Scalable'],
		image: serviceMobileApp,
	},
	{
		id: '02',
		title: 'Website Development',
		description:
			'Secure, scalable full-stack engineering for portals, dashboards, and custom web platforms.',
		tags: ['Full-Stack', 'Performance', 'SEO Ready'],
		image: serviceWebDev,
	},
	{
		id: '03',
		title: 'Database Management',
		description:
			'Robust data architecture, optimization, migration, and monitoring for reliable business operations.',
		tags: ['SQL/NoSQL', 'Migration', 'Security'],
		image: serviceDatabase,
	},
	{
		id: '04',
		title: 'Cloud & DevOps',
		description:
			'Deployment pipelines, observability, and infrastructure automation to keep systems stable and release-ready.',
		tags: ['CI/CD', 'Monitoring', 'Automation'],
		image: serviceCloudDevops,
	},
];

function Services() {
	return (
		<section id="services" className="space-y-6">
			<div className="mx-auto max-w-3xl text-center">
				<h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Services</h2>
				<p className="mt-3 text-base text-slate-600">
					Strategic product engineering services delivering measurable productivity, experience,
					and growth impact.
				</p>
			</div>

			<div className="space-y-5">
				{services.map((service, index) => (
					<section
						key={service.title}
						className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md sm:p-8"
					>
						<div className={`grid items-center gap-8 ${index % 2 === 0 ? 'lg:grid-cols-[1.1fr_0.9fr]' : 'lg:grid-cols-[0.9fr_1.1fr]'}`}>
							<div className={index % 2 === 0 ? 'order-2 lg:order-1' : 'order-2'}>
								<p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700">
									<span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-cyan-600 text-white">
										{service.id}
									</span>
									{service.title}
								</p>
								<h3 className="mt-4 text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
									{service.title}
								</h3>
								<p className="mt-4 max-w-xl text-lg leading-relaxed text-slate-600">{service.description}</p>
								<div className="mt-5 flex flex-wrap gap-2">
									{service.tags.map((tag) => (
										<span
											key={tag}
											className="rounded-lg bg-blue-600 px-3 py-1.5 text-sm font-medium text-white"
										>
											{tag}
										</span>
									))}
								</div>
								<a
									href="#contact"
									className="mt-8 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 px-5 py-3 text-sm font-semibold text-white transition hover:brightness-110"
								>
									Start your project
									<span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white/25">➜</span>
								</a>
							</div>

							<div className={index % 2 === 0 ? 'order-1 lg:order-2' : 'order-1'}>
								<div className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 p-3">
									<img
										src={service.image}
										alt={service.title}
										className="h-60 w-full rounded-xl object-cover sm:h-72"
										loading="lazy"
									/>
								</div>
							</div>
						</div>
					</section>
				))}
			</div>
		</section>
	);
}

export default Services;
